import privacyPolicyHtml from "../assets/Legal/PrivacyPolicy.md?html";
import { createRoute } from "../lib/createRoute";
import LegalMarkdown from "../pages/LegalMarkdown";

export const Route = createRoute(
  "/privacy-policy",
  () => <LegalMarkdown htmlText={privacyPolicyHtml} />,
  "Privacy Policy | Flowstep",
  "Flowstep values your privacy. This Privacy Policy explains how Flowstep collects, uses, and protects your personal data, and what you can do with your information.",
);
